import ApiService from './ApiService'

const endpoint = '/users'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: `${endpoint}/sign-in`,
        method: 'post',
        data,
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}

export async function apiSignInAffiliate(data) {
    return ApiService.fetchData({
        url: '/affiliates/sign-in',
        method: 'post',
        data,
    })
}

export async function apiSignInPatient(data) {
    return ApiService.fetchData({
        url: '/patients/sign-in',
        method: 'post',
        data,
    })
}
